/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Account_Confirm_DeleteInputs */

const en_delete_account_confirm_delete = /** @type {(inputs: Delete_Account_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, Delete`)
};

const es_delete_account_confirm_delete = /** @type {(inputs: Delete_Account_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, eliminar`)
};

const ar_delete_account_confirm_delete = /** @type {(inputs: Delete_Account_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نعم، احذف`)
};

/**
* | output |
* | --- |
* | "Yes, Delete" |
*
* @param {Delete_Account_Confirm_DeleteInputs} inputs
* @param {{ locale?: "en" | "es" | "ar" }} options
* @returns {LocalizedString}
*/
export const delete_account_confirm_delete = /** @type {((inputs?: Delete_Account_Confirm_DeleteInputs, options?: { locale?: "en" | "es" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Account_Confirm_DeleteInputs, { locale?: "en" | "es" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delete_account_confirm_delete(inputs)
	if (locale === "es") return es_delete_account_confirm_delete(inputs)
	return ar_delete_account_confirm_delete(inputs)
});